import {Entity, Type} from '../../pages/product/product.model';

export class ProjectTreeNode extends Entity
{

    // id: number;
    // name: string;
    // type: Type;
    // enabled: boolean;
    public children: ProjectTreeNode[];
    public parentId: number;
    public index: number;
    hasChildren: boolean;


    constructor(node?)
    {
        super(node);
        // node = node || {};
        // this.id = node.id || 0;
        // this.name = node.name;
        // this.type = node.type;
        // this.enabled = node.enabled;
        this.hasChildren = node.hasChildren;
        this.children = node.children;
        this.index = node.index;

    }

    // get children(): ProjectTreeNode[] {
    //     return this._children;
    // }

}
